const config = {
    API_URL: 'https://api.sharc.fm'
};

export default config;